/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AnalyticsFormDropoffAnalyticsPathParams,
	AnalyticsFormDropoffAnalyticsQueryParams,
	AnalyticsFormDropoffAnalyticsResponse,
} from '../types/AnalyticsFormDropoffAnalytics'

/**
 * GET /campaigns/:campaign/form-dropoff-analytics
 * @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::formDropoffAnalytics
 */
export async function analyticsFormDropoffAnalytics(
	campaign: AnalyticsFormDropoffAnalyticsPathParams['campaign'],
	params?: AnalyticsFormDropoffAnalyticsQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AnalyticsFormDropoffAnalyticsResponse>> {
	return axiosInstance.get(`/campaigns/${campaign}/form-dropoff-analytics`, { params, ...config })
}
